<template>
  <div class="about">
		<div class="pg-header">
			<div><label class="title">勿访</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>院中管理</span>|
					<span>勿访</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<div>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter(0, $event)"></el-input></div>
						<div>住院号<el-input size="small" maxlength="18" style="width:80px" v-model.trim="filter.admissionNumber" @keyup.enter.native="handleFilter(1, $event)"></el-input></div>
						<div>身份证号<el-input size="small" maxlength="18" style="width:180px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input></div>
						<div>入院诊断<el-input size="small" style="width:100px" v-model.trim="filter.inHospitalDiagnosis"  @keyup.enter.native="handleFilter(4, $event)"></el-input></div>
						<div>科室
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.inHospitalDepartmentId" @change="handleFilter(2, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
					</div>
					<div class="def-key">
						<div>入院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.inDate" :picker-options="pickerOptions" @change="handleFilter('inDate', $event)"></el-date-picker>
						</div>
						<div>勿访时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.dispenseDate" :picker-options="pickerOptions" @change="handleFilter('dispenseDate', $event)"></el-date-picker>
						</div>
						<div>出院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outDate" :picker-options="pickerOptions" @change="handleFilter('outDate', $event)"></el-date-picker>
						</div>
					</div>
					<div class="def-key">
						<div>排序条件
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.orderCondition" @change="handleFilter(6, $event)">
								<el-option v-for="item in filter.orderConditionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
						<div v-if="filter.orderCondition != 2">排序顺序
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.orderRule" @change="handleFilter(6, $event)">
								<el-option v-for="item in filter.orderRuleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column fixed="left" prop="name" label="姓名" width="100">
						<template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources}}"><span class="fc key">{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column prop="inHospitalDepartment" label="科室"></el-table-column>
					<el-table-column prop="admissionNumber" label="住院号" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="inHospitalDiagnosis" label="入院诊断" show-overflow-tooltip></el-table-column>					
					<el-table-column prop="hospitalBed" label="床号" width="130"></el-table-column>
					<el-table-column prop="inpatientArea" label="病区" width="130" show-overflow-tooltip></el-table-column>
					<!-- <el-table-column prop="manageProgress" label="管理进度"></el-table-column> -->
					<el-table-column prop="mainDoctor" label="责任医师" width="100"></el-table-column>
					<el-table-column prop="inHospitalDate" label="入院时间" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="updateTime" label="勿访时间" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="outHospitalDate" label="出院时间" width="120" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.outHospitalDate">{{scope.row.outHospitalDate}}</span>
							<span v-else>尚未出院</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" target="_blank" :enterable="false"><router-link :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources}}"><i class="icon-research"></i></router-link></el-tooltip>
									<el-tooltip content="回退" slot="reference" placement="top" :enterable="false"><i class="icon-sync" v-show="filter.recordState != 0 && permission" @click="openModal(scope.row)"></i></el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>

		<el-dialog title="分配疾病管理师" width="530px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="疾病管理师" prop="diseaseManagerId">
					<el-select size="small" filterable clearable placeholder="请选择" v-model="form.diseaseManagerId">
						<el-option v-for="item in managerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm1">保 存</el-button>
			</div>
		</el-dialog>
		<BackModal v-if="backdata.active" :backdata="backdata" @closeDlg="closeDlg"/>

  </div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import BackModal from './components/backModal.vue';
export default {
	components: {
		BackModal
	},
  mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					diseaseManagerId: {required: true, message: '请选择疾病管理师'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				inHospitalDepartmentId: '',
				diseaseManagerId: '',
				inHospitalDiagnosis: '',
				recordState: 4,//管理状态(0待分配，1管理中，2已结束，3已过期，4勿访)
				orderCondition:5,//1入院时间 2床号 3出院时间 4分配时间 5勿访时间
				orderConditionList: [
					{id:1,name:'入院时间'},
					{id:2,name:'床号正序'},
					{id:3,name:'出院时间'},
					// {id:4,name:'分配时间'},
					{id:5,name:'勿访时间'}
				],
				orderRule:2,//1正序 2倒序
				orderRuleList: [
					{id:1,name:'正序'},
					{id:2,name:'倒序'}
				],
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				id: 0,
				diseaseManager: '',
				diseaseManagerId: '',
				ids: [],
				recordState: 3,
			},
			deptList: [],
			managerList: [],
			backdata:{
				active: false,
				data:{},
				type:4
			}
		}
	},
	created() {
		// 获取 科室下拉
		api.getDeptDropdown({departmentType:0}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		})
		// 获取 疾病管理师下拉
		api.getComboboxUserList({roleId: 3}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.managerList = res.data;
			}
		})
		let query = this.$route.query;
		if(query.depId){
			this.filter.inHospitalDepartmentId=parseInt(query.depId);
		}
		if (query.date){
			this.filter.inHospitalDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
			this.filter.inHospitalDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
			this.filter.inDate = [this.filter.inHospitalDateStart, this.filter.inHospitalDateEnd];
		}
		this.loadList();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getHospitalPatientList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.inHospitalDate = dayjs(item.inHospitalDate).format('YYYY-MM-DD HH:mm:ss');
					item.recordId = item.id;
					item.id = item.ihdId;
					let inpatientArea = [];
					if(item.inpatientArea){inpatientArea.push(item.inpatientArea)}
					if(item.inpatientWard){inpatientArea.push(item.inpatientWard)}
					if(item.hospitalBed){item.hospitalBed +="床"}
					item.inpatientArea = inpatientArea.join('-');
				})
				this.list.data = res.data;
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "7") ? true : false;
			
			this.isLoading = false;
		},
		showDlg(item) {
			if (item && item.id > 0) {
				this.dlg.active = true;
				this.form.id = +item.id;
				this.form.diseaseManagerId = item.diseaseManagerId || '';
			} else {
				if (this.multipleSelection.length == 0) {
					return this.$message.warning('未选择任何数据');
				}
				this.dlg.active = true;
				this.form.id = 0;
				this.form.diseaseManagerId = '';
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
				});				
			}
		},
		openModal(item){
			this.backdata.active=true;
			this.backdata.data=item;
		},
		closeDlg(data) {
			this.dlg.active = false;
			this.backdata={
				active: false,
				data:{},
				type:4
			}
			if(data&&data=='sucess'){
				this.loadList();
			}
		},
		async saveForm1() {
			let res;
			// 分配
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let user = this.managerList.find((item)=>{if (item.id == this.form.diseaseManagerId) { return item;}});
					this.form.diseaseManager = user.name;
					this.form.recordState = 1;
					if (this.form.id > 0) {
						this.form.ids = this.form.id;
					} else {
						// 批量
						this.form.ids = this.multipleSelection.join(',');				
					}
					this.isLoading = true;
					res = await api.updateHospitalPatientState(this.form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.closeDlg();
					this.$message.success('保存成功');
					this.loadList();
				}
			})	
		},
		// 勿访
		async saveForm2(item) {
			let res;
			this.form.diseaseManager = '';
			this.form.diseaseManagerId = '';
			this.form.recordState = 1;
			if (item && item.id > 0) {
				this.form.ids = item.id;
			} else {
				// 批量
				if (this.multipleSelection.length == 0) {
					return this.$message.warning('未选择任何数据');
				}
				this.form.ids = this.multipleSelection.join(',');
			}
			this.isLoading = true;
			res = await api.updateHospitalPatientState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.closeDlg();
			this.$message.success('保存成功');
			this.loadList();
		},
		async saveForm3(item) {
			// 回退
			let res;
			this.isLoading = true;
			res = await api.rollbackrecordState({ihdid:item.ihdId,recordState:0});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},
		handleTab(){
			// 切换列表类型
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 'inDate'://入院时间
					if (this.filter.inDate) {
						this.filter.inHospitalDateStart = dayjs(this.filter.inDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.inHospitalDateEnd = dayjs(this.filter.inDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.inHospitalDateStart = '';
						this.filter.inHospitalDateEnd = '';						
					}
					break;
				case 'manageDate'://分配时间
					if (this.filter.manageDate) {
						this.filter.manageDateStart = dayjs(this.filter.manageDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.manageDateEnd = dayjs(this.filter.manageDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.manageDateStart = '';
						this.filter.manageDateEnd = '';						
					}
					break;
				case 'finishDate'://结束管理时间
					if (this.filter.finishDate) {
						this.filter.updateTimeStart = dayjs(this.filter.finishDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.updateTimeEnd = dayjs(this.filter.finishDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.updateTimeStart = '';
						this.filter.updateTimeEnd = '';						
					}
					break;
				case 'outDate'://出院时间
					if (this.filter.outDate) {
						this.filter.outHospitalDateStart = dayjs(this.filter.outDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.outHospitalDateEnd = dayjs(this.filter.outDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.outHospitalDateStart = '';
						this.filter.outHospitalDateEnd = '';						
					}
					break;
				case 'dispenseDate'://勿访时间
					if (this.filter.dispenseDate) {
						this.filter.updateTimeStart = dayjs(this.filter.dispenseDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.updateTimeEnd = dayjs(this.filter.dispenseDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.updateTimeStart = '';
						this.filter.updateTimeEnd = '';						
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}		
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.collapse-wrap {
	.search-bar {
		box-shadow: none;
	}
	.def-key {
		padding-bottom: 10px;
	}
	.table-wrap {
		box-shadow: none;
		.action-bar	{
			padding-top: 10px;
			display: block;
		}
	}
}
</style>